import React, { useState } from "react";

// STYLES
import * as Style from "./ButtonAtomStyle";

// LIBRARIES

// MISC
import { IProps } from "./ButtonAtomModel";
import { ButtonTypes } from "models/GeneralTypes/generalTypes";

// ASSETS
import HistoryIcon from "assets/Icons/HistoryIcon.svg";
import HistoryIconHovered from "assets/Icons/HistoryIconHovered.svg";
import DeleteIcon from "assets/Icons/DeleteIcon.svg";
import DeleteIconHovered from "assets/Icons/DeleteIconHovered.svg";
import EditIcon from "assets/Icons/EditIcon.svg";
import EditIconHovered from "assets/Icons/EditIconHovered.svg";

// REDUX

// COMPONENTS

const ButtonAtom = (props: IProps) => {

  // PROPS
  const { onClick = () => { }, text = "", type = "" } = props;

  // CONSTANTS USING LIBRARIES

  // CONSTANTS USING HOOKS
  const [isHovered, setIsHovered] = useState(false);

  // GENERAL CONSTANTS

  // USE EFFECT FUNCTION

  // REQUEST API FUNCTIONS

  // HANDLERS FUNCTIONS
  const handleRenderButton = () => {
    switch (type) {
      case ButtonTypes.MAIN_BUTTON:
        return <Style.MainButton
          onClick={onClick}>
          <Style.NewButtonAtomText>
            {text}
          </Style.NewButtonAtomText>
        </Style.MainButton>
      case ButtonTypes.SECONDARY_BUTTON_DEFAULT || ButtonTypes.SECONDARY_BUTTON_CANCEL:
        return <Style.SecondaryButton
          onClick={onClick}>
          <Style.NewButtonAtomText>
            {text}
          </Style.NewButtonAtomText>
        </Style.SecondaryButton>
      case ButtonTypes.SECONDARY_BUTTON_CANCEL:
        return <Style.SecondaryButtonCancel
          onClick={onClick}>
          <Style.CancelButtonAtomText>
            {text}
          </Style.CancelButtonAtomText>
        </Style.SecondaryButtonCancel>
      case ButtonTypes.SECONDARY_BUTTON_INACTIVE:
        return <Style.InactiveButtonCancel
          onClick={onClick}>
          <Style.InactiveButtonAtomText>
            {text}
          </Style.InactiveButtonAtomText>
        </Style.InactiveButtonCancel>
      case ButtonTypes.ICON_BUTTON_HISTORY:
        return <Style.IconButton
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          onClick={onClick}
        >
          <Style.IconImage
            src={isHovered ? HistoryIconHovered : HistoryIcon}
          />
        </Style.IconButton>
      case ButtonTypes.ICON_BUTTON_EDIT:
        return <Style.IconButton
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          onClick={onClick}
        >
          <Style.IconImage
            src={isHovered ? EditIconHovered : EditIcon}
          />
        </Style.IconButton>
      case ButtonTypes.ICON_BUTTON_DELETE:
        return <Style.DeleteIconButton
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          onClick={onClick}
        >
          <Style.IconImage
            src={isHovered ? DeleteIconHovered : DeleteIcon}
          />
        </Style.DeleteIconButton>

      // case ButtonTypes.DISABLED:
      //   return <Style.DisabledButton
      //     width={width}
      //     onClick={() => { }}
      //   >
      //     <Style.ButtonAtomText>
      //       {text}
      //     </Style.ButtonAtomText>
      //   </Style.DisabledButton>
    }
  }

  return (
    <>
      {handleRenderButton()}
    </>
  );
};

export default ButtonAtom;
